import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=6cf21661"
import script from "./effect.vue?vue&type=script&lang=js"
export * from "./effect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports